//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

//Import BootStrap Containers
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

//Navbar Component
const Navbar = (props, {store}) => 
{
    let theme = store.getState().theme;
    let userWindow = store.getState().userWindow;

    //defining style
    let contStyle = {
        // position: 'sticky'
        // height: '20vh',
        // justifyContent: 'center',
    }

    return (
    <Container fluid className={`${theme}`}
                style={contStyle}>
        <Row className="header-row">
            <Col sm={12} className="text-center">
                <h1 id='title'>
                    {
                        userWindow.titleColor.map((d,i) =>
                        <span key={i} style={{color: d[theme]}}>{d.letter}</span>)
                    }
                    <p className={`font-italic ${theme} navbar-subtitle`} id='userTest'>A handy tool for analysts, developers and designers</p>
                </h1>           
            </Col>
        </Row>
    </Container>
    )
}

Navbar.contextTypes = {
    store: PropTypes.object
}

export default Navbar